import { HttpClient } from './client';

/**
 * The {@link HttpClient} instance that should be used when interacting with the OJL Tracker
 * NextJS API on the client.
 */
export const apiClient = new HttpClient({
  baseUrl: '/api',
  headers: { 'Content-Type': 'application/json' },
});
